export enum PromocodeType {
  ClientPersonalForSharing = 1,
  Gift = 2,
}
